<template lang="html">
  <div class="admin-files-wrapper">
    <div class="title">
      <span>Pomoćne poruke</span>
      <locale-picker />
    </div>
    <div class="table-wrapper">
      <table>
        <thead>
          <tr>
            <td style="width: 40px;">id</td>
            <td>Poruka</td>
            <td style="width: 150px;"></td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="tutorial in tutorials" :key="tutorial.tut_id">
            <td>
              {{ tutorial.tut_id }}
            </td>
            <td>
              {{ tutorial.tut_name }}
            </td>
            <td>
              <div @click="openEditModal(tutorial)" class="btn">
                izmeni
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import LocalePicker from "@/components/header/LocalePicker.vue";
import { api } from "@/api";
import eventBus from "@/shared/eventBus.js";
export default {
  name: "adminFiles",
  components: {
    LocalePicker
  },
  data() {
    return {
      tutorials: []
    };
  },
  mounted() {
    this.getTutorials();
  },
  methods: {
    getTutorials() {
      api.getTutorials().then(res => {
        this.tutorials = res.data.data;
      });
    },
    openEditModal(tutorial) {
      let modalData = {
        title: "Izmeni " + tutorial.tut_name,
        tutorial: tutorial,
        ok: editedTutorial => {
          this.editTutorial(editedTutorial);
        }
      };
      let params = {
        modalData: modalData,
        component: "editTutorial"
      };
      eventBus.$emit("openModal", params);
    },
    editTutorial(tutorial) {
      let params = {
        tut_text: tutorial.tut_text,
        tut_id: tutorial.tut_id
      };
      api
        .editTutorial(params)
        .then(res => {
          this.getTutorials();
          this.$toast.success("Uspešno", {
            duration: 8000
          });
        })
        .catch(e => {
          console.log(e);
          this.$toast.error("Greška", {
            duration: 8000
          });
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.admin-files-wrapper {
  padding-left: 40px;
  box-sizing: border-box;
  @import "@/assets/scss/btnStyles.scss";
  @import "@/assets/scss/tableStyles.scss";
  height: 100%;
  position: relative;

  .table-wrapper {
    height: calc(100% - 100px);
    overflow: auto;
  }

  .title {
    margin-bottom: 25px;
    font-size: 21px;
    color: $text-color;
    text-align: left;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
  table {
    margin-bottom: 20px;
  }
  .action-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }
}
</style>
